(function () {
  function normalizeCount(count) {
    if (typeof count === "number") {
      return count < 0 ? 0 : count;
    }
    if (typeof count === "string") {
      var parsed = parseInt(count, 10);
      if (isNaN(parsed) || parsed < 0) return 0;
      return parsed;
    }
    return 0;
  }

  function getRebuyItemCount(fallback) {
    try {
      if (
        window.Rebuy &&
        Rebuy.Cart &&
        Rebuy.Cart.cart &&
        Rebuy.Cart.cart.item_count != null
      ) {
        return normalizeCount(Rebuy.Cart.cart.item_count);
      }
    } catch (e) {}
    if (fallback != null) {
      return normalizeCount(fallback);
    }
    return 0;
  }

  function updateHeaderCartCount(count) {
    var safeCount = normalizeCount(count);
    var bubbles = document.querySelectorAll("[data-cart-count-bubble]");

    bubbles.forEach(function (bubble) {
      var valueEl = bubble.querySelector("[data-cart-count-value]");
      var accessibleEl = bubble.querySelector("[data-cart-count-accessible]");
      if (!valueEl || !accessibleEl) return;

      if (safeCount === 0) {
        bubble.classList.add("cart-count-bubble--hidden");
      } else {
        bubble.classList.remove("cart-count-bubble--hidden");
      }

      if (safeCount < 100) {
        valueEl.textContent = safeCount;
        valueEl.removeAttribute("hidden");
      } else {
        valueEl.textContent = "99+";
        valueEl.removeAttribute("hidden");
      }

      accessibleEl.textContent = accessibleEl.textContent.replace(
        /\d+/,
        safeCount
      );
    });
  }

  function syncEmptyCartUI(count) {
    var safeCount = normalizeCount(count);
    var isEmpty = !safeCount || safeCount === 0;
    if (!isEmpty) return;

    var cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.close === "function") {
      cartDrawer.close();
    }

    document.documentElement.classList.remove("js-drawer-open");
    document.body.classList.remove("overflow-hidden");
  }

  function getRebuyCartFromEvent(event) {
    if (!event || !event.detail) return null;
    if (event.detail.cart) return event.detail.cart;
    if (event.detail.smart_cart && event.detail.smart_cart.cart) {
      return event.detail.smart_cart.cart;
    }
    return null;
  }

  document.addEventListener("rebuy:cart.change", function (event) {
    var cart = getRebuyCartFromEvent(event);
    var rawCount = cart && cart.item_count != null ? cart.item_count : 0;
    var count = getRebuyItemCount(rawCount);
    updateHeaderCartCount(count);
    syncEmptyCartUI(count);
  });

  document.addEventListener("rebuy:smartcart.ready", function (event) {
    var cart = getRebuyCartFromEvent(event);
    var rawCount = cart && cart.item_count != null ? cart.item_count : 0;
    var count = getRebuyItemCount(rawCount);
    updateHeaderCartCount(count);
    syncEmptyCartUI(count);
  });

  window.addEventListener("load", function () {
    try {
      var rawCount = 0;

      if (
        window.Rebuy &&
        Rebuy.SmartCart &&
        Rebuy.SmartCart.cart &&
        Rebuy.SmartCart.cart.item_count != null
      ) {
        rawCount = Rebuy.SmartCart.cart.item_count;
      }

      var count = getRebuyItemCount(rawCount);
      updateHeaderCartCount(count);
      syncEmptyCartUI(count);
    } catch (e) {}
  });
})();
